// MODEL JS START

$(document).ready(function() {
  // jQuery click handler
  $(document).on("click", "#trigger", function(e) {
    e.preventDefault();
    
    var pdfLink = $(this).attr('href');
    $('#myModal').find('.modal-content img').attr('src', pdfLink);
    $('#myModal').show();
  });

  // Native JS modal logic
  var modal = document.getElementById("myModal");
  var span = document.getElementsByClassName("close")[0];

  if (span) {
    span.onclick = function () {
      modal.style.display = "none";
    };
  }

  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };
});

// MODEL JS END


$(document).ready(function() {
  $('.logo-bar').slick({
    dots: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  $('.featured_slider_cart').slick({
      infinite: true,
      centerMode: false,
      slidesToShow: 2, 
      slidesToScroll: 1, 
      arrows: true, 
      dots: false
  });

  $(".js-drawer-open-cart").on("click",function(){
     $('.featured_slider_cart').slick('unslick');
      $('.featured_slider_cart').slick({
      infinite: true,
      centerMode: false,
      slidesToShow: 2, 
      slidesToScroll: 1, 
      arrows: true, 
      dots: false
    });
  });
  
}); 


(function () {
    var goTopBtn;

    function trackScroll() {
      var scrolled = window.pageYOffset;
      var halfPage = document.documentElement.scrollHeight / 2;

      if (scrolled > halfPage) {
        goTopBtn.classList.add('show');
      } else {
        goTopBtn.classList.remove('show');
      }
    }

    function backToTop() {
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        smoothScrollFallback();
      }
    }

    function smoothScrollFallback() {
      if (window.pageYOffset > 0) {
        window.scrollBy(0, -80);
        setTimeout(smoothScrollFallback, 10);
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      goTopBtn = document.querySelector('.back-to-top');

      // Only proceed if pagination exists
      var pagination = document.querySelector('.pagination');
      if (!pagination) return;

      window.addEventListener('scroll', trackScroll);
      goTopBtn.addEventListener('click', backToTop);
    });
  })();


